import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';
import { ContatoFormaSelectComponent } from './contato-forma-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ContatoFormaSelectComponent
    ],
    exports: [
        ContatoFormaSelectComponent
    ]
})
export class ContatoFormaSelectModule { }
